import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { StatefulControlledTextField } from "./Core/StatefulControlledTextField";

export default function InputTextPair({
  label,

  name,
  value,

  inputProps,
  disabled,
  isLoading,

  maskType,

  onChange,
}) {
  const handleChange = (event) => {
    onChange?.(event);
  };

  return (
    <Box className="mui-InputPair mui-InputTextPair">
      <Box
        sx={{
          p: 0,
          m: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            m: 0,
            height: "100%",
            boxSizing: "border-box",
            width: "50%",
          }}
        >
          <Typography sx={{ m: 0, p: 0 }}>{label}</Typography>
        </Box>
        <Box sx={{ width: "50%" }}>
          {(!disabled || isLoading) && (
            <StatefulControlledTextField
              fullWidth={true}
              name={name}
              className="noMargin"
              size="small"
              defaultValue={value || ""}
              onChange={handleChange}
              inputProps={inputProps}
              disabled={disabled}
              maskType={maskType}
              isLoading={isLoading}
            />
          )}
          {disabled && !isLoading && (
            <Typography
              variant="body1"
              sx={{
                borderBottom: "1px solid",
                borderColor: "grey.200",
                p: 0.5,
                ...inputProps?.sx,
              }}
            >
              {value || ""}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}
